// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + ".b442fb46f6ed8a2adb23a2248e2642a5.js";
};